<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.editRole')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>

                 <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.setting.editRole')}}</div>
                        <button class="btn btn-primary float-right" @click="updateRole"
                            :disabled="disableEditForm || !permissions.editSettingsRoles">{{$t('button.update')}}</button>
                    </div>

                    <form role="form">
                        <div class="card-body">
                            <div class="form-group">
                                <label>{{$t('form.setting.name')}}</label>
                                <input type="text" v-model="role.name" class="form-control">
                            </div>

                            <div class="form-group">
                                <label>{{$t('form.setting.availablePermissions')}}</label>
                                <div class="float-right">
                                    <label><input type="checkbox" v-model="selectAll">
                                        {{$t('form.setting.selectAll')}}</label>
                                </div>

                                <div class="bg-light p-2 mb-2" v-for="(permission, index) in availablePermissions"
                                    v-bind:key="index">
                                    <label>{{index | capitalize}} {{$t('form.setting.module')}}</label>
                                    <div class="permission-details">
                                        <div class="form-check clearfix">
                                            <label class="form-check-label custom-label" v-for="(p, i) in permission"
                                                v-bind:key="i">
                                                <input type="checkbox" class="form-check-input" v-model="p.checked" @change="closing=false">
                                                {{p.name}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['permissions', 'editFormInterval'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,

                isLoading: false,
                fullPage: true,
                closing: true,

                role: {
                    id: null,
                    name: null
                },

                selectAll: '',
                availablePermissions: {
                    settings: [],
                    students: [],
                    alumni: [],
                    HR: [],
                    programs: [],
                    companies: [],
                    courses: [],
                    books: [],
                    bookbundles: [],
                    invoices: [],
                    import: [],
                    notifications: [],
                    announcements: [],
                },
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsRoles) {
                this.$router.push('/');
                return;
            }

            if (this.permissions.editSettingsRoles) {
                this.checkForEdit();
                let self = this;

                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }

            this.getRole();
        },

        watch: {
            selectAll(isChecked) {
                Object.keys(this.availablePermissions).forEach((p) => {
                    this.availablePermissions[p].map(permission => {
                        permission.checked = isChecked;
                    });
                });
            },

            role: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },

            'availablePermissions': {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {
            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },

            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                this.getRole();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },



            getRole() {
                this.isLoading = true;

                axios
                    .get('/api/roles/' + this.$route.params.id + '/edit')
                    .then(response => {
                        this.role = response.data.role;
                        this.availablePermissions = response.data.permissions;

                        // mark checked if already attached
                        Object.keys(this.availablePermissions).forEach((p) => {
                            this.availablePermissions[p].map(permission => {
                                let found = response.data.role_permission.find(rp => rp.id ==
                                    permission.id);

                                if (found) {
                                    permission.checked = true;
                                }
                            });
                        });

                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 2000);
                    })
                    .catch(error => {
                        // console.log(error.response);

                        this.isLoading = false;
                    });
            },

            updateRole() {
                if (this.disableEditForm) {
                    return;
                }

                this.isLoading = true;
                let permissions = [];

                Object.keys(this.availablePermissions).forEach((p) => {
                    this.availablePermissions[p].map(permission => {
                        if (permission.checked) {
                            permissions.push(permission.id);
                        }
                    });
                });

                axios
                    .put("/api/roles/" + this.$route.params.id, {
                        role: JSON.stringify(this.role),
                        permissions: permissions
                    })
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.status == 'success') {

                            clearInterval(this.interval);

                            this.showAlert(response.data.message);
                            this.$emit('roleUpdated');

                            setTimeout(() => this.$router.push({
                                name: 'RoleIndex'
                            }), 2000);
                        }
                    })
                    .catch(error => {
                        console.log(error.response);

                        this.isLoading = false;
                    });
            }
        },

        beforeRouteLeave(to, from, next) {
              clearInterval(this.interval);
            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    }

</script>
<style scoped>
    .custom-label {
        font-size: 90%;
        display: block;
        width: 33%;
        float: left;
    }

    .custom-form-group {
        padding: 0px 30px;
    }

</style>
